<template>
  <div>
    <v-alert dense color="secondary darken-3" dark style="position:sticky; left: 0; top: 0; right: 0; margin-bottom: 4px; z-index: 1; min-height: 3.8em">
      <transition name="slide" mode="out-in">
        <v-row key="1" align="center" v-if="category === null">
          <v-col>
            <h3 class="my-2" v-if="loading"><T key="1">Загрузка меню...</T></h3>
            <h3 class="my-2" v-else><T key="2">Выберите категорию</T></h3>
          </v-col>
        </v-row>
        <v-row key="2" align="center" v-else>
          <v-col class="shrink">
            <v-btn test-tag="tag-117" large icon @click="category = null"><v-icon>mdi-chevron-left</v-icon></v-btn>
          </v-col>
          <v-col class="grow">
            <v-icon large class="mr-2">mdi-folder-open</v-icon>
            <h3 style="display: inline">{{category.name}}</h3>
          </v-col>
          <v-btn test-tag="tag-118" rounded @click="searchActive = !searchActive"><v-icon>mdi-magnify</v-icon></v-btn>
        </v-row>   
      </transition>
      <v-expand-transition>
        <v-text-field test-tag="tag-119" v-show="searchActive && category" v-model="search" clearable dense outlined filled hide-details/>
      </v-expand-transition>
    </v-alert>
        <!-- <div > -->
    <transition name="fade" mode="out-in">
      <v-skeleton-loader
        v-if="loading"
        type="date-picker"
      ></v-skeleton-loader> 
      <div key="1" class="d-flex" style="flex-wrap: wrap; gap: .3em" v-else-if="category === null">
        <NavigatorCard @click="itemClick(item)" v-for="item in menu_merged_items" :key="item.id" :item="item" style="position: relative">
          {{item.alt_name || item.name}}
          <v-icon x-large dark style="opacity: .3;position: absolute; bottom: .2em; right: .2em">mdi-folder-move</v-icon>
        </NavigatorCard>
      </div>
      <div key="2" class="d-flex pb-2" style="flex-wrap: wrap; gap: .3em" v-else>
        <NavigatorCard :disabled="validating || !item.prices[price_address]" @click="itemClick(item)" v-for="item in sorted" :key="item.id" :item="item" :style="`position: relative; display: ${item.prices[price_address] ? 'block' : 'none'}`">
          <div style="height: 6.4em; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 4; -webkit-box-orient: vertical;">
            {{item.alt_name || item.name}}
          </div>
          <div v-if="item.prices[price_address]">
            {{item.prices[price_address].toFixed(2)}}
          </div>
          <!-- <div v-else>
            <T>Нет цены</T>
          </div> -->
          <v-icon x-large dark style="opacity: .3;position: absolute; bottom: .2em; right: .2em">mdi-food</v-icon>
        </NavigatorCard>
      </div>
    </transition>
    <!-- </div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import NavigatorCard from './NavigatorCard.vue'

export default {
  props: ['price_address', 'loading', 'validating'],
  data: () => ({
    category: null,
    search: '',
    searchActive: false
  }),
  methods: {
    itemClick(item) {
      if (this.category === null) {
        this.category = item
        this.$emit('click:category', item)
      } else {
        this.$emit('click:item', item)
      }
    },
  },
  computed: {
    ...mapGetters(['menu_merged_items']),
    items(){
      if (this.category !== null) {
        return this.category.items
      } else {
        return this.menu_merged_items
      }
    },

    sorted(){
      if(this.searchActive && this.search) 
        return this.category.items.filter((item) => 
        item.name.toLowerCase().includes((this.search).toLowerCase()) 
        || item.alt_name.toLowerCase().includes((this.search).toLowerCase())
      )
      return [...this.items].sort((a,b) => a.name > b.name ? 1 : -1)   
    }
  },
  watch: {
    category(val){
      if(!val) {
        this.search = ''
        this.searchActive = false
      }
    }
  },
  components: {
    NavigatorCard
  }
}
</script>